'use strict';
import angular from 'angular';
import './base/industrybenchmarkleadtracking.resources';


angular.module('core.industrybenchmarkleadtracking', [
    'industrybenchmarkleadtracking.resources'
]);